import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject, Observable } from 'rxjs';
import { ResizeManagerService } from './resize-manager.service';
import { StorageManagerService } from './storage-manager.service';

const MENU_STATE_KEY = "MENU_STATE"

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  
  private _open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _headerTitle: BehaviorSubject<string> = new BehaviorSubject<string>("")
  private _electronOS: string = null
  private _isCustomer: boolean = false
  public _showNothing: boolean = false
  public _showNavigation: boolean = true

  public isOpenAfterAnimation: boolean = false

  constructor(
    private platform: Platform,
    private deviceDetector: DeviceDetectorService,
    private ngZone: NgZone
  ) { 
    this.platform.ready().then(()=>{
      if(this.platform.is("electron")) this._electronOS = this.deviceDetector.os
    })
    this._open.next(false)
  }


  public get electronOS(): string{
    return this._electronOS
  }

  public get isMenuOpenValue(): boolean{
    return this._open.value
  }

  public get isMenuOpen():Observable<boolean>{
    return this._open.asObservable();
  }

  public get isCustomer(): boolean{
    return this._isCustomer
  }

  public set isCustomer(val: boolean){
    this._isCustomer = val
  }

  public set showNothing(value: boolean){
    this._showNothing = value
  }

  public get showNothing(): boolean{
    return this._showNothing
  }

  public get showNavigation(): boolean{
    return this._showNavigation
  }

  public set showNavigation(value: boolean){
    this._showNavigation = value
  }

  public closeMenu(){
    this.ngZone.run(() => {
      this.isOpenAfterAnimation = false
      this._open.next(false)
    })
  }

  public openMenu(){
    this.ngZone.run(() => {
      this._open.next(true)
      setTimeout(() => this.isOpenAfterAnimation = true, 500);
    })
  }

  public toggleMenu(){
    this.ngZone.run(() => {
      this._open.next(!this._open.value)
      if(this._open.value)
        setTimeout(() => this.isOpenAfterAnimation = true, 500);
    })
  }
  

  //Header
  public headerTitle(): Observable<string>{
    return this._headerTitle.asObservable()
  }

  public setHeaderTitle(text: string): void{
    this._headerTitle.next(text)
  }

}
